<template>
  <form>
    <slot></slot>
  </form>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";
</style>
